import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';
// api
import * as merchantAPI from 'api/merchant';

// ----------------------------------------------------------------------

type merchantState = {
  isLoading: boolean;
  error: boolean;
  permit_list: any[];
  role_list: any[];
};

const initialState: merchantState = {
  isLoading: false,
  error: false,
  permit_list: [],
  role_list: []
};

const slice = createSlice({
  name: 'merchant',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    setSchoolData(state, { payload }) {
      return { ...state, ...payload };
    },
    setRole_list(state, { payload }) {
      state.isLoading = false;
      state.role_list = payload;
    }
  }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------
// Actions
export const { setSchoolData } = slice.actions;

// action

/// 获取该学校信息
export function fetchSchoolData(params: any) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await merchantAPI.getMainSchool(params);

      // update only role_list
      if (params && params.only) {
        dispatch(slice.actions.setRole_list(response.role_list));
        return;
      }

      dispatch(slice.actions.setSchoolData(response));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
